<template>
  <div class="d-flex flex-wrap" style="gap: .5rem">
    <template v-if="!isLoading">
      <template v-if="badges.length">
        <b-badge
          v-for="(item, index) in badges"
          :key="index"
          class="p-1"
          :class="`${getClass} ${item.class}`"
          :variant="variant"
          :pill="pill"
          :style="customColor(item)"
        >
          {{ text(item) }}
        </b-badge>
      </template>
    </template>
    <template v-else>
    <div v-if="Array.isArray(value)" class="d-flex flex-wrap" style="gap: .5rem">
      <b-skeleton v-for="item in 4" :key="item" width="80px"></b-skeleton>
    </div>
    <b-skeleton width="80px" v-else></b-skeleton>
    </template>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: [String, Object, Boolean, Array],
      required: true
    },
    pill: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'secondary'
    },
    populate: {
      type: Boolean,
      default: false
    },
    populateEndpoint: {
      type: String,
      default: null
    },
    displayProp: {
      type: String,
      default: null
    }
  },
  computed: {
    getClass () {
      let classes = ''
      if (this.pill) {
        classes += 'px-2'
      }
      return classes
    }
  },
  data () {
    return {
      isLoading: false,
      badges: []
    }
  },
  methods: {
    text (item) {
      if (typeof item === 'boolean') {
        return item ? 'Si' : 'No'
      }
      return typeof item === 'string' ? item : item.name
    },
    customColor (item) {
      if (item?.color) {
        return `background-color: ${item.color}`
      }
      if (item === true) {
        return 'background-color: green'
      } else if (item === false) {
        return 'background-color: red'
      }
      return ''
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.populate) {
        if (Array.isArray(this.value)) {
          const items = []
          for (const item of this.value) {
            const res = await commonsApi.axiosGetWrapper(this.populateEndpoint + '/' + item)
            items.push({
              id: res.data._id,
              name: res.data[this.displayProp || 'name']
            })
          }
          this.badges = items
        } else {
          const res = await commonsApi.axiosGetWrapper(this.populateEndpoint + '/' + this.value)
          this.badge = {
            id: res.data._id,
            name: res.data[this.displayProp || 'name']
          }
        }
      } else {
        if (this.value || this.value.length) {
          this.badges = [this.value].flat()
        } else if (this.value === false) {
          this.badges = [this.value]
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
<style lang="sass">
.document-status.color-2, .document-status:hover.color-2
  background-color: violet

.document-status.color-3, .document-status:hover.color-3
  background-color: orange

.document-status.color-4, .document-status:hover.color-4
  background-color: cadetblue

.document-status.color-6, .document-status:hover.color-6
  background-color: green

.document-status.color-7, .document-status:hover.color-7
  background-color: rebeccapurple

.document-status.color-9, .document-status:hover.color-9
  background-color: red

.process-status.color-5, .process-status:hover.color-5
  background-color: yellow
  color: black

.process-status.color-3, .process-status:hover.color-3
  background-color: orange

.process-status.color-6, .process-status:hover.color-6
  background-color: cadetblue

.process-status.color-7, .process-status:hover.color-7
  background-color: green

.process-status.color-8, .process-status:hover.color-8
  background-color: violet

.process-status.color-9, .process-status:hover.color-9
  background-color: rebeccapurple

.process-status.color-10, .process-status:hover.color-10
  background-color: red

.process-status.color-11, .process-status:hover.color-11
  background-color: plum
  color: black

.process-status.color-12, .process-status:hover.color-12
  background-color: teal

.process-status.color-13, .process-status:hover.color-13
  background-color: tomato

.process-status.color-14, .process-status:hover.color-14
  background-color: turquoise
</style>
